import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, API_BASE } from "@/lib/api";
import fallbackLogo from "@/assets/logo-presthyg.png";

const BrandingContext = createContext(null);

// Logo affiché tant qu'aucun logo n'a été téléversé dans Paramètres -> Branding.
// Servi par le bundle local : aucune dépendance à un hébergeur externe.
const FALLBACK_LOGO = fallbackLogo;

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState({
    company_name: "Prest'Hyg",
    logo_file_id: null,
  });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings/branding/public");
      setBranding({
        company_name: data.company_name || "Prest'Hyg",
        logo_file_id: data.logo_file_id || null,
      });
    } catch (_e) {
      /* keep defaults */
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const logoUrl = branding.logo_file_id
    ? `${API_BASE}/files/${branding.logo_file_id}/download`
    : FALLBACK_LOGO;

  return (
    <BrandingContext.Provider value={{ ...branding, logoUrl, refresh }}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  const ctx = useContext(BrandingContext);
  if (!ctx) throw new Error("useBranding must be inside BrandingProvider");
  return ctx;
}

export function logoForFile(fileId) {
  return fileId ? `${API_BASE}/files/${fileId}/download` : null;
}
